import { useState } from 'react';

export default function FAQSection() {
  const faqs = [
    {
      q: 'Чем B2B продажи отличаются от B2C?',
      a: 'В B2B цикл сделки длиннее, участвует несколько лиц принимающих решение, решение принимается рационально, а не эмоционально. Работают закупочные процедуры, тендеры, согласования. Важны отношения, доверие и способность влиять на процесс принятия решения на разных уровнях организации клиента. Именно поэтому большинство техник из B2C здесь не работают.',
    },
    {
      q: 'Сколько длится обучение?',
      a: 'Форматы варьируются: интенсивный тренинг — 1–2 полных дня, модульная программа — от 2 недель до 3 месяцев, комплексная программа с сопровождением — 3–12 месяцев. Точная продолжительность определяется после диагностики текущего уровня команды и поставленных бизнес-целей.',
    },
    {
      q: 'Можно ли обучить опытных менеджеров?',
      a: 'Да. Опытные менеджеры часто работают «по наитию» и не осознают системных ошибок. Тренинг помогает структурировать их опыт, добавить недостающие инструменты (работа с картой ЛПР, управление длинным циклом, стратегия influence) и вывести продажи на новый уровень. Практика на реальных сделках делает обучение релевантным для любого уровня.',
    },
    {
      q: 'Подходит ли программа производственным компаниям?',
      a: 'Да, более половины наших проектов — производственные и промышленные компании. Мы работаем со сложными продуктами, длинным циклом сделки, тендерными процедурами и многоуровневыми закупками. Программа адаптируется под специфику вашей отрасли: оборудование, компоненты, сырьё или готовая продукция.',
    },
    {
      q: 'Работаете ли вы с экспортными продажами?',
      a: 'Да. Мы работаем с компаниями из Беларуси, России и Казахстана, которые выходят на международные рынки. Обучаем кросс-культурным переговорам, работе с иностранными закупщиками и адаптации стратегии продаж под специфику разных стран.',
    },
    {
      q: 'Можно ли провести обучение онлайн?',
      a: 'Да, тренинг полностью доступен в онлайн-формате: живые сессии с отработкой диалогов через видеосвязь, ролевые переговоры, детальный разбор реальных записей встреч и звонков. Онлайн-формат полностью сохраняет практическую направленность программы.',
    },
    {
      q: 'Есть ли сопровождение после тренинга?',
      a: 'Да, посттренинговое сопровождение — ключевой элемент нашей методологии. Мы разбираем новые переговоры, поддерживаем участников в Telegram, помогаем внедрять стандарты. Именно сопровождение превращает тренинг из «мероприятия» в устойчивый рост результатов. Без него эффективность любого тренинга падает на 70–80% уже через месяц.',
    },
    {
      q: 'Можно ли адаптировать программу под нашу специфику?',
      a: 'Каждая программа разрабатывается индивидуально после диагностики. Мы изучаем ваш продукт, рынок, цикл сделки, конкурентов, текущий уровень менеджеров. Ни одной шаблонной программы — только то, что работает в вашей нише.',
    },
    {
      q: 'Что делать, если цикл сделки 6 месяцев?',
      a: 'Для длинных сделок мы строим систему управления воронкой: карта ЛПР, стратегия influence, промежуточные KPI, follow-up система, прогнозирование. Менеджеры учатся вести сделку месяцами, не теряя контроль и не «сливая» её на финальном этапе. Программа включает специальный модуль по управлению длинным циклом.',
    },
    {
      q: 'Можно ли разобрать реальные сделки компании?',
      a: 'Это основа нашей методологии. Мы разбираем текущие сделки участников прямо на тренинге: анализируем карту ЛПР, стратегию переговоров, ошибки в аргументации. Это в десятки раз эффективнее абстрактных кейсов из учебников. Участники видят свои реальные ошибки и тут же получают инструменты для их исправления.',
    },
    {
      q: 'Можно ли обучить КАМов и менеджеров по работе с ключевыми клиентами?',
      a: 'Да, программа включает модуль по работе с ключевыми клиентами: развитие отношений, выявление потенциала, cross-sale и up-sale, удержание и лояльность. КАМы учатся стратегическому управлению портфелем клиентов и построению долгосрочных партнёрств.',
    },
    {
      q: 'Когда появляются первые результаты?',
      a: 'Первые изменения в качестве переговоров заметны уже во время тренинга — на 2-й день участники иначе готовятся к встречам и ведут диалог. Измеримый рост конверсии обычно проявляется через 1–2 месяца при условии посттренингового сопровождения и внедрения стандартов. Системные изменения в отделе продаж занимают 3–6 месяцев.',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-question-answer-line"></i>
            FAQ
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ответы на самые частые вопросы о тренинге по B2B продажам.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-100 overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full text-left px-5 md:px-6 py-4 flex items-center justify-between gap-4 cursor-pointer group hover:bg-gray-50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-gray-900">{faq.q}</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === i ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-500 group-hover:bg-teal-100 group-hover:text-teal-600'}`}>
                  <i className={`text-sm transition-transform ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-out overflow-hidden ${openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="px-5 md:px-6 pb-5 text-sm text-gray-600 leading-relaxed">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}